// Small per-browser list of recently opened patients for the command palette and dashboard.
// Holds only id + display name; cleared on logout.
const KEY = 'recent-patients';
const MAX = 8;

export interface RecentPatient {
  id: string;
  name: string;
  phone?: string;
  at: number;
}

export const getRecentPatients = (): RecentPatient[] => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as RecentPatient[]) : [];
  } catch {
    return [];
  }
};

export const rememberPatient = (patient: { id?: string; fullName?: string; firstName?: string; lastName?: string; phoneNumber?: string }) => {
  if (!patient.id) return;
  const name = patient.fullName || [patient.firstName, patient.lastName].filter(Boolean).join(' ');
  if (!name) return;
  try {
    const next = [
      { id: patient.id, name, phone: patient.phoneNumber, at: Date.now() },
      ...getRecentPatients().filter((p) => p.id !== patient.id),
    ].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* storage unavailable */
  }
};

export const clearRecentPatients = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* storage unavailable */
  }
};
